<template>
  <div class="tree-item">
    <mu-button
      icon
      :ripple="false"
      :class="['fold-btn', { show: showChildren }]"
      v-if="data.children && data.children.length > 0"
      @click="fold"
    >
      <mu-icon value="arrow_right"></mu-icon>
    </mu-button>
    <div
      class="button-place"
      v-if="!data.children || data.children.length === 0"
    ></div>
    <mu-tooltip
      :content="data.description"
      v-if="data.description"
      placement="top"
    >
      <mu-checkbox
        class="check-btn"
        :label="data.name"
        @change="checkChange(data)"
        :input-value="checked"
      ></mu-checkbox>
    </mu-tooltip>
    <mu-checkbox
      class="check-btn"
      :label="data.name"
      @change="checkChange(data)"
      :input-value="checked"
      v-else
    ></mu-checkbox>
    <div
      class="children"
      v-if="data.children && data.children.length > 0"
      v-show="showChildren"
    >
      <TreeItem
        v-for="(item, index) in data.children"
        :key="index"
        :data="item"
        @itemChange="itemChange"
        :checked="selectedMenuList.some((x) => x.id === item.id)"
        :selectedMenuList="selectedMenuList"
      ></TreeItem>
    </div>
  </div>
</template>

<script>
import TreeItem from './treeItem'
export default {
  name: 'TreeItem',
  components: { TreeItem },
  props: {
    data: {
      type: Object
    },
    checked: {
      type: Boolean
    },
    selectedMenuList: {
      type: Array
    }
  },
  data() {
    return {
      showChildren: false
    }
  },
  methods: {
    fold() {
      this.showChildren = !this.showChildren
    },
    checkChange(data) {
      this.$emit('itemChange', data)
    },
    itemChange(data) {
      this.$emit('itemChange', data)
    }
  },
  mounted() {
    if (this.data.menuLevel === '一级') {
      this.showChildren = true
    }
  }
}
</script>

<style lang="less" scoped>
.tree-item {
  .fold-btn {
    transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    &.show {
      transform: rotate(90deg);
    }
  }
  .check-btn {
    position: relative;
    right: 14px;
  }
  .button-place {
    width: 48px;
    display: inline-block;
  }
  .label {
    display: inline-block;
    height: 48px;
    line-height: 48px;
  }
  .children {
    padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tree/treeItem.vue